var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:_vm.valueClass,style:(_vm.textColor)},[_vm._v(" "+_vm._s(_vm.formatValue)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }